// Sentry должен быть инициализирован ПЕРВЫМ — до любых других импортов,
// чтобы перехватывать ошибки даже в момент загрузки приложения.
import { initSentry } from './lib/sentry';
initSentry();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App.tsx';
import './styles/index.css';

// StrictMode работает только в dev — вызывает эффекты дважды чтобы ловить
// забытые cleanup'ы, предупреждает о deprecated API. В production ничего не делает.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
